import React from "react";
import { array } from "prop-types";

import "./entities.m.css";

const Entities = ({ entities }) => {
  if (!(entities && entities.length)) {
    return null;
  }

  return (
    <ul styleName="wrapper">
      {entities.map((item, index) => (
        <li key={index}>{item.name}</li>
      ))}
    </ul>
  );
};

Entities.propTypes = {
  entities: array
};

export default Entities;
